module.exports = __webpack_public_path__ + "static/media/Download.d40c5e32.svg";